var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { useEffect } from 'react';
import { getTypographyStyles, TYPOGRAPHY_TYPE } from '../../../theme/typography';
import { useTheme } from '../../../theme';
import { GROUP_TYPE, useGroup } from '../Group';
import { COLOR } from '../../../theme/colors';
import { useEnvironment } from '../../providers/env';
import { multiplyRemSize } from '../../../utils/misc';
export var HEADING_SIZE;
(function (HEADING_SIZE) {
    HEADING_SIZE["SM"] = "sm";
    HEADING_SIZE["MD"] = "md";
    HEADING_SIZE["LG"] = "lg";
    HEADING_SIZE["XL"] = "xl";
})(HEADING_SIZE || (HEADING_SIZE = {}));
const SIZE_TYPOGRAPHY_MAP = {
    [HEADING_SIZE.SM]: TYPOGRAPHY_TYPE.HEADING_SMALL,
    [HEADING_SIZE.MD]: TYPOGRAPHY_TYPE.HEADING_MEDIUM,
    [HEADING_SIZE.LG]: TYPOGRAPHY_TYPE.HEADING_LARGE,
    [HEADING_SIZE.XL]: TYPOGRAPHY_TYPE.HEADING_XLARGE,
};
const LEVEL_TYPOGRAPHY_MAP = {
    1: TYPOGRAPHY_TYPE.HEADING_XLARGE,
    2: TYPOGRAPHY_TYPE.HEADING_LARGE,
    3: TYPOGRAPHY_TYPE.HEADING_MEDIUM,
    4: TYPOGRAPHY_TYPE.HEADING_SMALL,
    5: TYPOGRAPHY_TYPE.HEADING_SMALL,
    6: TYPOGRAPHY_TYPE.HEADING_SMALL,
};
export const Heading = (_a) => {
    var _b, _c;
    var { sx, size, standalone, id, underline, underlineColor, typography: typographyProp, level: levelParam } = _a, rest = __rest(_a, ["sx", "size", "standalone", "id", "underline", "underlineColor", "typography", "level"]);
    const { level: groupLevel, type, trackHeadingRendered } = useGroup();
    const { flagInDevelopment } = useEnvironment();
    const theme = useTheme();
    const level = levelParam || groupLevel;
    useEffect(() => {
        trackHeadingRendered();
    });
    let typography = TYPOGRAPHY_TYPE.HEADING_MEDIUM;
    if (typographyProp) {
        typography = typographyProp;
    }
    else if (size) {
        typography = SIZE_TYPOGRAPHY_MAP[size];
    }
    else if (level) {
        typography =
            LEVEL_TYPOGRAPHY_MAP[level];
    }
    const typographyStyles = getTypographyStyles(typography);
    const getMarginHeightMultiple = (level) => {
        if (level > 4) {
            return 0.75;
        }
        if (level === 1 || level === 2) {
            return 0.375;
        }
        return 0.55;
    };
    const marginHeightMultiple = (((_b = theme.lineHeights) === null || _b === void 0 ? void 0 : _b[typographyStyles.lineHeight]) || 1.625) *
        getMarginHeightMultiple(level);
    const fontSize = ((_c = theme.fontSizes) === null || _c === void 0 ? void 0 : _c[typographyStyles.fontSize]) || '1rem';
    const topMargin = multiplyRemSize({
        size: fontSize,
        multiple: marginHeightMultiple,
    });
    if (type !== GROUP_TYPE.REGION && !standalone) {
        flagInDevelopment('Heading component should be used within a Group component with property type={GROUP_TYPE.REGION} or given the standalone flag');
    }
    const headerProps = Object.assign({ id: id, role: 'heading', 'aria-level': level, sx: Object.assign(Object.assign({ py: 0, borderBottom: underline ? 'solid 2px' : undefined, borderBottomColor: underlineColor ? underlineColor : COLOR.SECONDARY, color: COLOR.PRIMARY, mt: topMargin }, getTypographyStyles(typography)), sx) }, rest);
    switch (level) {
        case 1:
            return _jsx("h1", Object.assign({}, headerProps));
        case 2:
            return _jsx("h2", Object.assign({}, headerProps));
        case 3:
            return _jsx("h3", Object.assign({}, headerProps));
        case 4:
            return _jsx("h4", Object.assign({}, headerProps));
        case 5:
            return _jsx("h5", Object.assign({}, headerProps));
        case 6:
            return _jsx("h6", Object.assign({}, headerProps));
        default:
            return _jsx("h6", Object.assign({}, headerProps));
    }
};
